import "./header.css";

import { faFacebook, faInstagram, faLinkedin, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faBars } from "@fortawesome/free-solid-svg-icons";

import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Links } from "../../../constants/_imports";
import { TextBtn } from "../../_imports";
import NameLogoPreta from "../../../assets/logo/logo_name_preta.svg";

function Header() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    return (
        <header className="HeaderSection" id="header">
            <section className="TopHeaderSection">
                <section className="TopHeader">
                    <div className="Slogan">
                        <p className="slogan-text">"Simplificando o recrutamento!"</p>
                    </div>
                    <div className="SocialButtons">
                        <a href={Links.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Whatsapp">
                            <FontAwesomeIcon className="IconsHeader" icon={faWhatsapp} />
                        </a>
                        <a href={Links.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                            <FontAwesomeIcon className="IconsHeader" icon={faFacebook} />
                        </a>
                        <a href={Links.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                            <FontAwesomeIcon className="IconsHeader" icon={faInstagram} />
                        </a>
                        <a href={Links.linkding} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                            <FontAwesomeIcon className="IconsHeader" icon={faLinkedin} />
                        </a>
                    </div>
                </section>
            </section>
            <section className="BottonHeaderSection">
                <section className="BottonHeader">
                    <div className="Logo">
                        <img src={NameLogoPreta} alt="Logo Tonalida"></img>
                    </div>
                    <nav className="MenuContaier">
                        <FontAwesomeIcon onClick={toggleMenu} className="MenuIcon" icon={faBars} />
                        <div className={`MenuOverlay ${isOpen ? "OverlayOpen" : ""}`} onClick={toggleMenu}></div>
                        <div className={`MenuButtons ${isOpen ? "MenuOpen" : "MenuClose"}`}>
                            <TextBtn link="/" text="Início" onClick={() => setIsOpen(false)} />
                            <TextBtn link="/blog" text="Blog" onClick={() => setIsOpen(false)} />
                            <TextBtn link="/empresa" text="Para Empresas" onClick={() => setIsOpen(false)} />
                            <TextBtn link="/candidato" text="Para Candidatos" onClick={() => setIsOpen(false)} />
                            <TextBtn link={Links.portal} text="Portal" onClick={() => setIsOpen(false)} />
                        </div>
                    </nav>
                </section>
            </section>
        </header>
    );
}

export default Header;